import checkLocalesExist from "./check-locales-exist.js";

export default {
	checkLocalesExist,
};
